document.addEventListener("DOMContentLoaded", function () {
  const tableParentSelector = ".gpnf-nested-entries"; // Replace with the actual selector for your table parent
  const intervalDelay = 500; // Delay in milliseconds for the interval

  // Keep track of processed fields to avoid reprocessing
  const processedFields = new Set();

  // Function to process product fields
  function processProductFields() {
    const productFields = document.querySelectorAll(
      'td.gpnf-field[data-heading="Product"]'
    );
    let unprocessedFields = 0;

    productFields.forEach((field) => {
      const productId = field.getAttribute("data-value");

      if (productId && !processedFields.has(field)) {
        // console.log("Processing Product ID:", productId);

        fetchProductTitle(productId, field);
        processedFields.add(field); // Mark field as processed
      } else if (!processedFields.has(field)) {
        // console.warn("No valid Product ID found for field:", field);
      }

      if (!processedFields.has(field)) {
        unprocessedFields++;
      }
    });

    // Return true if all fields are processed
    return unprocessedFields === 0;
  }

  // Interval to keep checking for the tableParent
  const interval = setInterval(() => {
    const tableParent = document.querySelector(tableParentSelector);
    if (tableParent && processProductFields()) {
      clearInterval(interval); // Stop the interval once fields are processed
      // console.log("Table content processed, stopping interval.");
    }
  }, intervalDelay);

  // Observer for dynamically added rows in the table
  const tableParent = document.querySelector(tableParentSelector);
  if (tableParent) {
    const observer = new MutationObserver(() => {
      // console.log("Mutation detected, processing product fields.");
      processProductFields();
    });

    observer.observe(tableParent, { childList: true, subtree: true });
  }
});

// Define the fetchProductTitle function
function fetchProductTitle(productId, field) {
  fetch(ajax_object.ajax_url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      action: "get_product_title", // Match your server-side AJAX action
      product_id: productId,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        // Keep the data-value as the numeric product ID
        field.setAttribute("data-value", productId);

        // Replace the inner HTML with the product title
        field.innerHTML = data.data.title;
       // console.log(
        //  `Updated Product ID ${productId} with title: ${data.data.title}`
      //  );
      } else {
       // console.error(`Product title not found for ID: ${productId}`);
      }
    })
    .catch((error) => {
     // console.error(`Error fetching product title for ID: ${productId}`, error);
    });
}